"use client";

import React from "react";
import Image from "next/image";
import { motion } from "framer-motion";
import appendImageUrlFromAPI from "@/utils/appendImageUrlFromAPI";

interface DecoImageProps {
  side: "left" | "right";
  isActive: boolean;
  isDesktop: boolean;
  img_url: string;
}

export const DecoImage = ({
  side,
  isActive,
  isDesktop,
  img_url,
}: DecoImageProps) => {
  const isLeft = side === "left";

  return (
    <motion.div
      initial={{
        x: isLeft ? -150 : 150,
        opacity: 1,
        rotate: isLeft ? -10 : 10,
      }}
      animate={
        isActive || !isDesktop
          ? {
              x: 0,
              opacity: 1,
              rotate: isLeft ? [10, 0, -10] : [-10, 0, 10],
              transition: {
                duration: 1.2,
                ease: "easeOut",
              },
            }
          : {
              x: isLeft ? -200 : 200,
              opacity: 1,
              rotate: isLeft ? -20 : 20,
              transition: {
                duration: 0.8,
                ease: "easeIn",
              },
            }
      }
      whileHover={{
        scale: 1.05,
        rotate: isLeft ? -5 : 5,
        transition: { duration: 0.3 },
      }}
      style={{
        position: "absolute",
        [isLeft ? "left" : "right"]: isLeft ? "-9vw" : "-8vw",
        top: isLeft ? "12%" : "52%",
        transform: "translateY(-50%)",
        width: isLeft ? "11vw" : "10vw",
        aspectRatio: "1/1",
        borderRadius: "24px",
        overflow: "hidden",
        zIndex: 3,
        pointerEvents: "none",
        boxShadow: "0 12px 35px rgba(0,0,0,0.22)",
      }}
    >
      <Image
        src={appendImageUrlFromAPI({ src: img_url, size: "xl" })}
        alt={`deco ${side}`}
        fill
        style={{
          objectFit: "cover",
        }}
      />
    </motion.div>
  );
};
